var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"},[_c('statistics-card-line',{attrs:{"icon":_vm.data.icon,"statistic":_vm.data.total,"statisticTitle":_vm.data.title,"chartData":_vm.data.chartData,"type":_vm.data.chart_type,"color":_vm.data.color}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }